/* eslint-disable no-restricted-syntax */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserDepositBonusModel, UserProfileModel, WSChatMessage, WSFriendsGameInviteMessage, WSStatsMessage } from 'mvppoker-portal-common/api'

export interface ProfileData
{
	otherProfiles: UserProfileModel[],
	otherProfilesLookup: { [userId: string] : UserProfileModel },
	depositBonus?: UserDepositBonusModel,
    gameInvite?: WSFriendsGameInviteMessage,
	chats: { [userId: string] : WSChatMessage[] },
	unreadChats: { [userId: string] : boolean },
	lastUnreadChat?: WSChatMessage,
	hasUnreadChat: boolean
	lobbyChat: WSChatMessage[]
	lobbyStats: WSStatsMessage
}

const initialState : ProfileData =
{
	otherProfiles: [],
	otherProfilesLookup: {},
	depositBonus: undefined,
	gameInvite: undefined,
	chats: {},
	unreadChats: {},
	lastUnreadChat: undefined,
	hasUnreadChat: false,
	lobbyChat: [],
	lobbyStats: { usersCount: 0 }
}

export const profileDataSlice = createSlice({
	name: 'ProfileData',
	initialState,
	reducers: {
		setOtherProfiles: (state, action: PayloadAction<UserProfileModel[]>) => {
			state.otherProfiles = action.payload
			const lookup : { [userId: string] : UserProfileModel } = {}
			for(const p of action.payload){
				lookup[p.userId] = p
			}
			state.otherProfilesLookup = lookup
		},
		setDepositBonus: (state, action: PayloadAction<UserDepositBonusModel | undefined>) => {
			state.depositBonus = action.payload
		},
		setGameInvite: (state, action: PayloadAction<WSFriendsGameInviteMessage | undefined>) => {
			state.gameInvite = action.payload
		},
		addChatMessage: (state, action: PayloadAction<[string, WSChatMessage, boolean]>) => {
			const [userId, chatMessage, isFromUser] = action.payload
			const cs = { ...state.chats }
			const chat = cs[userId] ?? []
			chat.push(chatMessage)
			cs[userId] = chat
			state.chats = cs
			if (!isFromUser) {
				const unreadChats = { ...state.unreadChats }
				unreadChats[userId] = true
				state.unreadChats = unreadChats
				state.hasUnreadChat = true
			}
		},
		setLastUnreadChat: (state, action: PayloadAction<WSChatMessage | undefined>) => {
			state.lastUnreadChat = action.payload
		},
		setReadChat: (state, action: PayloadAction<string>) => {
			const unreadChats = { ...state.unreadChats }
			unreadChats[action.payload] = false
			state.unreadChats = unreadChats
			state.hasUnreadChat = Object.values(unreadChats).reduce((prev, curr) => prev || curr)
		},
		updateLobbyChat: (state, action: PayloadAction<WSChatMessage[]>) => {
			state.lobbyChat = action.payload
		},
		addLobbyChatMessage: (state, action: PayloadAction<WSChatMessage>) => {
			const MAX_MESSAGES = 10
			let chat = [...state.lobbyChat]
			chat.push(action.payload)
			if (chat.length > MAX_MESSAGES) {
				chat = chat.slice(chat.length - MAX_MESSAGES, chat.length)
			}
			state.lobbyChat = chat
			// state.hasUnreadLobbyChat = true
		},
		// setLobbyChatRead: (state) => {
		// 	state.hasUnreadLobbyChat = false
		// },
		updateLobbyStats: (state, action: PayloadAction<WSStatsMessage>) => {
			state.lobbyStats = action.payload
		},
	},
})

export const { setOtherProfiles, setDepositBonus, setGameInvite, addChatMessage, setLastUnreadChat, setReadChat, updateLobbyChat, addLobbyChatMessage, updateLobbyStats } = profileDataSlice.actions

export default profileDataSlice.reducer
